<template>
  <v-form ref="login">
    <v-container class="pt-0">
      <v-layout :column="mobile" :align-baseline="!mobile">
        <v-flex>
          <v-text-field
              v-model="email"
              label="Email or Phone"
              name="email"
              :error="!!getUserError"
              :error-messages="getUserError"
          >
          </v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
              v-model="password"
              label="Password"
              name="password"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :type="show ? 'text' : 'password'"
              @click:append="show = !show"
              :error="!!getPasswordError"
              :error-messages="getPasswordError"
          >
          </v-text-field>
        </v-flex>
        <v-flex>
          <v-btn round block color="accent" @click.prevent="submitLogin" type="submit" :loading="isLoading">
            <span class="black--text">Log In</span>
          </v-btn>
        </v-flex>
      </v-layout>
      <router-link to="/reset_password" :class="{'accent--text': dark}">Forgot Password?</router-link>
    </v-container>
  </v-form>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: "LogIn",
        props: {
            column: {
                default: false,
                type: Boolean
            },
            dark: {
                default: true,
                type: Boolean
            },
            redirect: String
        },
        data() {
            return {
                show: false,
                email: "",
                password: "",
            }
        },
        methods: {
            ...mapActions('auth', ['login', 'fetchUserInfo']),

            submitLogin() {
                if (!this.email || !this.password)
                    return
                const data = {
                    userid: this.email,
                    password: this.password
                }
                this.login(data).then(() => {
                    if (this.isSuccess) {
                        let redirect = this.$route.query.redirect
                        let query = Object.assign({}, this.$route.query)
                        delete query.InstaplayId
                        delete query.userid
                        delete query.redirect
                        this.$router.push({path: redirect || this.redirect || '/home', query})
                    }
                })
            }
        },
        computed: {
            ...mapGetters('auth', ['isLoading', 'isSuccess', 'getUserError', 'getPasswordError']),

            mobile() {
                return this.$vuetify.breakpoint.xsOnly || this.column
            }
        },
        mounted() {
            this.email = this.$route.query.userid
        }
    }
</script>

<style scoped>

</style>
